exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form__input[data-v-12ab0c8e]{background-color:#fff}.form__input .region[data-v-12ab0c8e]{display:block}.form__input .region[data-v-12ab0c8e]:not(:last-child){margin-bottom:5px}.form__input .language-js[data-v-12ab0c8e]{padding:0;margin:0;background-color:#fff}", ""]);

// exports
